import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const ToolsMenuContainer = styled.div`
  padding: 6.5px 0;
  background-color: ${Variables.colors.complementary};
`;
export const ToolsListContainer = styled.div`
  overflow-y: auto;
  height: auto;
  overflow-x: hidden;
  width: 100%;
  .tools-header {
    border-bottom: 1px solid ${Variables.colors.complementary_300};
    margin-bottom: 3.5px;
  }
  .tools-footer {
    border-top: 1px solid ${Variables.colors.complementary_300};
    margin-top: 3.5px;
  }
  .tool-item {
    cursor: pointer;
    background-color: ${Variables.colors.complementary};
    height: 32px;
    list-style-type: none;
    display: flex;
    a, .disabled-a {
      width: 100%;
      padding: 12px 16px;
      display: flex;
      align-items: center;
      //justify-content: space-between;
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.medium};
      line-height: 1.62;
      text-decoration: none;
      .link-external-icon {
        display: none;
        &:before {
          margin: 0 !important;
          font-size: 16px;
          color: ${Variables.colors.complementary_500};
        }
      }
      .icon{
        margin-right: 8px;
        color: ${Variables.colors.yellow_500};
      }
      &.disable-link{
        cursor: not-allowed;
      }
    }
    &:hover {
      background-color: ${Variables.colors.complementary_200};
      .link-external-icon {
        display: block;
      }
    }
  }
`;
